import { Box, styled } from "@mui/material";

// Styled component for ProfileBorderBox
export const ProfileBorderBox = styled(Box)(
  ({ theme }) => `
    border-radius: 5px;
    border: 0.7px solid rgba(34, 51, 84, 0.1);
    background: #FDFEFE;
    padding: ${theme.spacing(2)} 0;
    min-height: 100%;
    max-height: 85vh;
    overflow-y: scroll;
  `
);

// Styled component for ProfileContainer
export const ProfileContainer = styled(Box)(
  ({ theme }) => `
    border-radius: 10px;
    background: #F5F8F8;
    padding: ${theme.spacing(2)} ${theme.spacing(2)};

     & .MuiTypography-h3{
         color: ${theme.colors.primary.main};
        font-size: ${theme.text.fontSizes.lg};
        font-style: normal;
        font-weight: ${theme.text.fontWeights.regular};
        line-height: normal;
        text-align: center;
        margin: 0 auto;
        margin-bottom: ${theme.spacing(2.5)};
         }
        & .profileLabel{
          font-size: ${theme.text.fontSizes.md};
          font-style: normal;
          font-weight: ${theme.text.fontWeights.light};
          line-height: normal;
          color: #575859;
          margin-bottom: ${theme.spacing(1)};
        }
          & .profileContentText{
          font-size: ${theme.text.fontSizes.md};
          font-style: normal;
          font-weight: ${theme.text.fontWeights.regular};
          line-height: normal;
          color: #000;
          margin-bottom: ${theme.spacing(1)};
        }
  `
);

// Styled component for ProfileViewContainer
export const ProfileViewContainer = styled(Box)(
  ({ theme }) => `
    border-radius: 10px;
    background: #F5F8F8;
    padding: ${theme.spacing(2)} ${theme.spacing(2)};
  `
);
export const FormInnerContainer = styled(Box)(
  ({ theme }) => `
   height:50vh;
   overflow-y:scroll;
  `
);

// Styled component for ProfileDetailsBox
export const ProfileDetailsBox = styled(Box)(
  ({ theme }) => `
    & .MuiTypography-h3 {
      font-feature-settings: 'liga' off, 'clig' off;
      font-size: ${theme.text.fontSizes.lg};
      font-style: normal;
      font-weight: ${theme.text.fontWeights.medium};
      line-height: 20px; /* 83.333% */
      background: linear-gradient(90deg, ${
        theme.colors.primary.main
      } 0%, #07B998 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      margin-bottom: ${theme.spacing(1)};
    }
    & p {
      color: #000;
      font-size: ${theme.text.fontSizes.sm};
      font-style: normal;
      font-weight: ${theme.text.fontWeights.light};
      line-height: normal;
    }
  `
);

// Styled component for ImageCircledPreview
export const ImageCircledPreview = styled(Box)(
  ({ theme }) => `
    position: relative; /* Enable positioning for the icon */
    width: 110px;
    height: 110px;
    padding-top: 15px;
    
    & img {
      width: 100px;
      height: 100px;
      object-fit: contain;
      border-radius: 200px;
      background: #F5F8F8;
      padding: ${theme.spacing(2)};
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Add box shadow */
    }

    & .icon-button {
      position: absolute;
      bottom: 30%; /* Adjust for placement */
x      right: 20%; /* Adjust for placement */
      background: #F5F8F8; /* Optional: Add a subtle background */
      border-radius: 50%;
      box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.2); /* Optional: Add shadow */
      z-index: 10; /* Ensure it appears above the image */
      padding: 2px;
      width: 20px;
      height: 20px;
    }
  `
);
